import { render, staticRenderFns } from "./bookTypes.vue?vue&type=template&id=46d27e34&"
import script from "./bookTypes.vue?vue&type=script&lang=js&"
export * from "./bookTypes.vue?vue&type=script&lang=js&"
import style0 from "./bookTypes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports